const LOGIN_URL = process.env.AUTH_URL + '/login';
const SAML_URL = process.env.AUTH_URL + '/saml';
const SIGNIN_URL = process.env.AUTH_URL + '/signin';
const REFRESH_URL = process.env.AUTH_URL + '/refresh';
const EMAIL_VERIFICATION_URL = process.env.AUTH_URL + '/emailverification';
const RESET_PASSWORD_EMAIL_URL = process.env.AUTH_URL + '/password/sendmail';
const RESET_PASSWORD_URL = process.env.AUTH_URL + '/password/reset';

const LOGIN_HEADER = 'X-Is-Login';
const REFRESH_HEADER = 'X-Is-Refresh';

const emailVerification = (context, verificationToken) => {
  const headers = {};
  headers[LOGIN_HEADER] = 'true';
  return context.$http.post(EMAIL_VERIFICATION_URL, verificationToken, {headers: headers});
};

const resetPasswordEmail = (context, username) => {
  const headers = {};
  headers[LOGIN_HEADER] = 'true';
  return context.$http.post(RESET_PASSWORD_EMAIL_URL, username, {headers: headers});
};

const login = (context, credentials) => {
  const headers = {};
  headers[LOGIN_HEADER] = 'true';
  return context.$http.post(LOGIN_URL, credentials, {headers: headers});
};

const loginSaml = (context) => {
  const headers = {};
  headers[LOGIN_HEADER] = 'true';
  return context.$http.get(SAML_URL, {headers: headers});
};

const signin = (context, user) => {
  const headers = {};
  headers[LOGIN_HEADER] = 'true';
  return context.$http.post(SIGNIN_URL, user, {headers: headers});
};

const resetPasswordForm = (context, user) => {
  const headers = {};
  headers[LOGIN_HEADER] = 'true';
  return context.$http.post(RESET_PASSWORD_URL, user, {headers: headers});
};

const refresh = (context) => {
  const headers = {};
  headers[REFRESH_HEADER] = 'true';
  return context.$http.post(REFRESH_URL, {}, {headers: headers});
};

export default {
  login,
  loginSaml,
  signin,
  refresh,
  emailVerification,
  resetPasswordEmail,
  resetPasswordForm,
  LOGIN_HEADER,
  REFRESH_HEADER
};



// WEBPACK FOOTER //
// ./src/api/auth/authHttp.js